module.exports = __webpack_public_path__ + "img/k2.8062cda6.png";